// Format epoch date to September 2nd 2024, 9:30, used in DivisionInfo.js
export const formatEpochToLongDateAndTime = (epoch) => {
    const date = new Date(epoch * 1000);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return `${date.toLocaleDateString(undefined, options)}`;
  };

// Function to format the date from epoch in format "18 Jan 2025"
export const formatEpochDate = (epoch) => {
    const date = new Date(epoch * 1000);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const day = date.getDate();
    const month = months[date.getMonth()].slice(0, 3);
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }

// Function to format the date from epoch in format "18 Jan 2025"
export const processEpochMini = (epoch) => {
  let then = new Date(epoch * 1000);
  let now = new Date();
  let diff = now - then;
  let days = Math.floor(diff / (1000 * 60 * 60 * 24));
  let hours = Math.floor(diff / (1000 * 60 * 60));
  let mins = Math.floor(diff / (1000 * 60));
  
  if (days > 365) {
    return `${Math.floor(days / 365)}y`;
  } else if (days > 30) {
    return `${Math.floor(days / 30)}mo`;
  } else if (days > 7) {
    return `${Math.floor(days / 7)}w`;
  } else if (days > 0) {
    return `${days}d`;
  } else if (hours > 0) {
    return `${hours}h`;
  } else {
    return `${mins}min`;
  }
};

// Format an epoch date into format "18 Jan 2025, 9:30PM"
export const formatFaceoffTimeDate = (epochTimestamp) => {
  // Create a new Date object using the epoch timestamp
  const date = new Date(epochTimestamp * 1000); // Multiply by 1000 to convert from seconds to milliseconds

  // Define an array of month names for formatting
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Get the day, month, and year
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  
  // Get the hours and minutes
  let hours = date.getHours();
  let minutes = date.getMinutes();
  // Convert to 12-hour time
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  // Add a leading zero to minutes if necessary
  minutes = minutes < 10 ? `0${minutes}` : minutes;

  // Return the formatted date and time
  return `${day} ${month.substring(0, 3)

  } ${year} ${hours}:${minutes}${ampm}`;
}

export const defaultSeason = () => {
  let today = new Date();
  let year = today.getFullYear();

  // console.log(today)

  if (today.getMonth() < 7) {
    let lastYear = year - 1;

    return {
      value: 0,
      title: lastYear.toString().substr(-2) + "-" + year.toString().substr(-2)
    }
  } else {
    let nextYear = year + 1;

    return {
      value: 0,
      title: year.toString().substr(-2) + "-" + nextYear.toString().substr(-2)
    }
  }
}

export const allSeasons = () => {
  let start = defaultSeason();

  let seasons = [start]

  let current_year = parseInt(start.title.split("-")[0])

  let current_offset = 1;

  while (current_year > 5) {
    let prev_year = current_year - 1;

    seasons.push({
      value: current_offset,
      title: prev_year.toString().padStart(2, '0') + "-" + current_year.toString().padStart(2, '0')
    })

    current_year = prev_year;
    current_offset += 1;
  }

  return seasons;
}